import { CellType } from './cell'
import { lineFromVehicle } from '../lineAppearance'
import {
  millisecondsToMinutes,
} from 'common/utils/time'
import { convertToTransitKind } from 'common/utils/transitKinds'
import { iconFromVehicle, colorFromVehicle } from '../../vehicle'

const scheduledDetailCellFromTicketsHop = (response, hopIndex) => {
  const hop = response.hops[hopIndex]
  const carrier = hop.marketingCarrier != null ? response.carriers[hop.marketingCarrier] : null
  const vehicle = response.vehicles[hop.vehicle]
  const fallbackIcon = {
    icon: iconFromVehicle(vehicle.kind),
    color: colorFromVehicle(vehicle.kind),
  }

  let secondaryText = null
  let lineDetails = null
  if (vehicle.kind === 'plane') {
    const secondaryTexts = []
    if (carrier) {
      const flightNumber = `${carrier.code}${hop.name ? hop.name : ''}`
      secondaryTexts.push(flightNumber)
    }
    if (vehicle.name) {
      secondaryTexts.push(vehicle.name)
    }
    secondaryText = secondaryTexts.join(' • ')
    lineDetails = {
      carrierName: carrier ? carrier.name : null,
    }
  } else {
    let lineDescription = null
    if (hop.name && hop.name.trim()) {
      lineDescription = hop.name.trim()
    }
    const line = response.lines[hop.line]
    lineDetails = {
      ...(carrier && carrier.name) && { carrierName: carrier.name },
      ...(lineDescription) && { description: lineDescription },
      ...(line.direction) && { direction: line.direction },
      ...(line.name) && { lineName: line.name },
    }
  }

  lineDetails.transitKind = convertToTransitKind(vehicle.kind)

  let iconUrl = null
  if (carrier && carrier.iconUrl) {
    // This check is needed to ensure icons work when the product is run locally.
    // When local, the url has the form "[PATH]" and be unaltered.
    // When not local, the url has the form "//[HOST][PATH]" and should be prepended with "https"
    if (carrier.iconUrl.indexOf('//') === 0) {
      iconUrl = `https:${carrier.iconUrl}`
    } else {
      iconUrl = carrier.iconUrl
    }
  }

  return {
    type: CellType.Detail,
    durationInMinutes: hop.duration,
    ...(secondaryText) && { secondaryText },
    hopIndex,
    ...(iconUrl) && { iconUrl },
    line: lineFromVehicle(vehicle.kind),
    fallbackIcon,
    lineDetails,
  }
}

const scheduledDetailCellFromCheckoutHop = (hop, operator) => {
  const carrier = operator.name
  const vehicle = hop.kind
  const fallbackIcon = {
    icon: iconFromVehicle(vehicle),
    color: colorFromVehicle(vehicle),
  }

  let secondaryText = null
  let lineDetails = null
  if (vehicle === 'plane') {
    const secondaryTexts = []
    if (carrier) {
      const flightNumber = `${carrier.code}${carrier.name ? carrier.name : ''}`
      secondaryTexts.push(flightNumber)
    }

    lineDetails = {
      carrierName: carrier ? carrier.name : null,
    }
  } else {

    let lineDescription = null
    if (hop.name && hop.name.trim()) {
      lineDescription = hop.name.trim()
    }

    lineDetails = {
      ...(operator && operator.name) && { carrierName: operator.name },
      ...(lineDescription) && { description: lineDescription },
    }
  }

  lineDetails.transitKind = convertToTransitKind(vehicle)

  let iconUrl = null
  if (operator && operator.logo) {
    // This check is needed to ensure icons work when the product is run locally.
    // When local, the url has the form "[PATH]" and be unaltered.
    // When not local, the url has the form "//[HOST][PATH]" and should be prepended with "https"
    const logo = operator.logo
    if (logo.indexOf('//') === 0) {
      iconUrl = `https:${logo}`
    } else {
      iconUrl = logo
    }
  }

  return {
    type: CellType.Detail,
    durationInMinutes: millisecondsToMinutes(hop.duration),
    ...(secondaryText) && { secondaryText },
    ...(iconUrl) && { iconUrl },
    line: lineFromVehicle(vehicle),
    fallbackIcon,
    lineDetails,
  }
}

export {
  scheduledDetailCellFromTicketsHop,
  scheduledDetailCellFromCheckoutHop
}
